class IdentifyClient {
    generateUUID = () => {
        const array = new Uint8Array(16);
        window.crypto.getRandomValues(array);
        return Array.from(array, (byte) => byte.toString(16).padStart(2, "0")).join("");
    };

    getOrCreateDeviceId = () => {
        let deviceId = localStorage.getItem("host_client");
        if (!deviceId) {
            deviceId = this.generateUUID();
            localStorage.setItem("host_client", deviceId);
        }
        return deviceId;
    };

    getDeviceId() {
        return this.getOrCreateDeviceId();
    }
}


export default new IdentifyClient();